
import { Bell, Settings, Megaphone, BarChart3 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { NotificationSettingsManagement } from '@/components/settings/NotificationSettingsManagement';
import { EnhancedNotificationsList } from '@/components/notifications/EnhancedNotificationsList';
import { BroadcastNotificationForm } from '@/components/notifications/BroadcastNotificationForm';
import { BroadcastHistory } from '@/components/notifications/BroadcastHistory';
import { EmployeeNotificationPreferences } from '@/components/settings/EmployeeNotificationPreferences';

export default function NotificationsPage() {
  return (
    <div className="container mx-auto p-4 md:p-6 max-w-6xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
          <Bell className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">الإشعارات</h1>
          <p className="text-gray-600">إدارة الإشعارات وإعداداتها</p>
        </div>
      </div>

      <Tabs defaultValue="notifications" className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="notifications" className="flex items-center gap-2">
            <Bell className="w-4 h-4" />
            الإشعارات
          </TabsTrigger>
          <TabsTrigger value="broadcast" className="flex items-center gap-2">
            <Megaphone className="w-4 h-4" />
            إرسال جماعي
          </TabsTrigger>
          <TabsTrigger value="history" className="flex items-center gap-2">
            <BarChart3 className="w-4 h-4" />
            السجل
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="w-4 h-4" />
            الإعدادات
          </TabsTrigger>
        </TabsList>

        <TabsContent value="notifications">
          <EnhancedNotificationsList />
        </TabsContent>

        <TabsContent value="broadcast">
          <BroadcastNotificationForm />
        </TabsContent>

        <TabsContent value="history">
          <BroadcastHistory />
        </TabsContent>

        <TabsContent value="settings" className="space-y-6">
          <EmployeeNotificationPreferences />
          <NotificationSettingsManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}
